import React from 'react';
import MainPurpleMarker from '../images/marker/main-purple.jpg'
import LightPurpleMarker from '../images/marker/light-purple.jpg'
import MainGreenMarker from '../images/marker/main-green.jpg'
import LightGreenMarker from '../images/marker/light-green.jpg'

declare const L: any;

const Map: React.FunctionComponent<any> = ({ type, points, selectedPoint, onMarkerSelect, onLegendClick, showingCGI, setShowingCGI, showingMGI, setShowingMGI }) => {
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  let initialZoom = 4;
  if (width < 768) {
    initialZoom = 3;
  }

  const initialLocation = [38.967243, -99.771556];
  const focusZoom = 12;
  const [mapInitialized, setMapInitialized] = React.useState(false);
  const [map, setMap] = React.useState<any>(null);
  const [selected, setSelected] = React.useState(null);
  // eslint-disable-next-line
  const [markers, setMarkers] = React.useState<any>(null);
  const [markersLayers, setMarkersLayers] = React.useState<any>(null);

  const createMakers = (points: any, cgiVisible: boolean, mgiVisible: boolean) => {
    let filteredCGI = [];
    if (cgiVisible) {
      filteredCGI = points.filter((point: any) => point.isCGI);
    }

    let filteredMGI = [];
    if (mgiVisible) {
      filteredMGI = points.filter((point: any) => !point.isCGI);
    }

    const markersLayer = L.markerClusterGroup();

    let CustomIcon = L.Icon.extend({
      options: {
        iconSize: [25, 25],
      }
    });


    const combinedPoints = [...filteredCGI, ...filteredMGI];

    let markersArray = [];
    for (let i = 0; i < combinedPoints.length; i++) {
      const marker = L.marker(
        [combinedPoints[i].latitude, combinedPoints[i].longitude],
        {
          id: 'marker-' + i + '-' + (combinedPoints[i].isCGI ? 'cgi' : 'mgi'),
          data: combinedPoints[i],
          icon: new CustomIcon({
            iconUrl: combinedPoints[i].pilot_program === "Yes" ? (!combinedPoints[i].isCGI ? MainPurpleMarker : MainGreenMarker) : (!combinedPoints[i].isCGI ? LightPurpleMarker : LightGreenMarker)
          }),
        }
      )
        .on('click', (event: any) => {
          onMarkerSelect(event.target.options.data.id);
        });


      markersArray.push(marker);
      markersLayer.addLayer(marker);
    }

    setMarkers(markersArray);
    setMarkersLayers(markersLayer)
    map?.addLayer(markersLayer);
  }

  const initializeMap = (points: any) => {
    if (points && points.length > 0 && !mapInitialized) {
      setMapInitialized(true);
      let mymap = L.map('mapid').setView(initialLocation, initialZoom);
      mymap.scrollWheelZoom.disable()

      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 19
      }).addTo(mymap);

      const markersLayer = L.markerClusterGroup();
      mymap.addLayer(markersLayer);

      let CustomIcon = L.Icon.extend({
        options: {
          iconSize: [25, 25],
        }
      });

      let filteredPoints = points
      if (showingCGI) {
        filteredPoints = filteredPoints.filter((point: any) => point.isCGI);
      }

      if (showingMGI) {
        filteredPoints = filteredPoints.filter((point: any) => !point.isCGI);
      }

      let markersArray = [];
      for (let i = 0; i < filteredPoints.length; i++) {
        const marker = L.marker(
          [filteredPoints[i].latitude, filteredPoints[i].longitude],
          {
            id: 'marker-' + i + '-' + (filteredPoints[i].isCGI ? 'cgi' : 'mgi'),
            data: filteredPoints[i],
            icon: new CustomIcon({
              iconUrl: filteredPoints[i].pilot_program === "Yes" ? (!filteredPoints[i].isCGI ? MainPurpleMarker : MainGreenMarker) : (!filteredPoints[i].isCGI ? LightPurpleMarker : LightGreenMarker)
            }),
          }
        )
          .on('click', (event: any) => {
            onMarkerSelect(event.target.options.data.id);
          });

        markersArray.push(marker);
        markersLayer.addLayer(marker);
      }

      setMarkers(markersArray);
      setMarkersLayers(markersLayer)
      setMap(mymap);
    }
  };

  const focusPoint = () => {
    map?.setView([selectedPoint.latitude, selectedPoint.longitude], focusZoom);
  };

  const clearFocus = () => {
    map?.setView(initialLocation, initialZoom);
  };

  const showPoints = (pointType: string) => () => {
    markersLayers.clearLayers();
    map.removeLayer(markersLayers);
    map.removeLayer(markers);

    if (pointType === 'mgi') {
      setShowingMGI(type === 'mgi' ? true : !showingMGI);
    } else {
      setShowingCGI(type === 'cgi' ? true : !showingCGI);
    }
    onLegendClick(pointType);
  }

  React.useEffect(() => {
    initializeMap(points);
    if (selectedPoint) {
      setSelected(selectedPoint);
    } else {
      setSelected(null);
    }
    // eslint-disable-next-line
  }, [selectedPoint, points]);

  React.useEffect(() => {
    if (selected) {
      focusPoint();
    } else {
      clearFocus();
    }
    // eslint-disable-next-line
  }, [selected]);

  React.useEffect(() => {
    createMakers(points, showingCGI, showingMGI);
  }, [showingCGI, showingMGI]);

  return (
    <main className="mt-24 h-72 md:w-2/6 md:flex-1 md:mt-0 md:h-screen md:p-6 relative">
      <div className='legend absolute'>
        <ul>
          <li><div onClick={type !== 'mgi' && type ? showPoints('mgi') : () => {}} className={`${showingMGI && type !== 'mgi' ? 'mgi' : ''} ${!type || type === 'mgi' ? `mgi` : ''}`}></div>Mayors</li>
          <li><div onClick={type !== 'cgi' && type ? showPoints('cgi') : () => {}} className={`${showingCGI && type !== 'cgi' ? 'cgi' : ''} ${!type || type === 'cgi' ? `cgi` : ''}`}></div>County Officials</li>
        </ul>
      </div>
      <div id="mapid" className="w-full h-full"></div>
    </main>
  )
}

export default Map;